import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MediumSquareFilledSvg from "@ant-design/icons-svg/es/asn/MediumSquareFilled";
import AntdIcon from '../components/AntdIcon';
var MediumSquareFilled = function MediumSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: MediumSquareFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(MediumSquareFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'MediumSquareFilled';
}
export default RefIcon;